const PRESS_REVIEWS = [
    {
        title: "Foothills brings 'Mockingbird' to life",
        subtitle: null,
        source: "David Brooks Andrews, News Correspondent",
        text: "Deanna Dunmyer as Jean Louise, the grown-up Scout, provides a natural, appealing narration with a gentle Southern accent and an ability to mentally bridge her adult and younger self as she looks back.",
    },
    {
        title: "Foothills' 'To Kill' stands on its own",
        subtitle: "Young actors' portrayals unpretentious",
        source: "Worcester Telegram and Gazette",
        text: "Deanna Dunmyer is heart-rending as Jean Louise Finch. There is never a moment when one feels she is obtrusive to the narrative flow. Dunmyer's final scene is a voice-cracking epiphany of emotion: looking across the stage at the girl she once was, running into her father's arms in a state of euphoric understanding.",
    },
    {
        title: "Courageous 'Desire'",
        subtitle: null,
        source: "Valley News",
        text: "Deanna Dunmyer is also impressive in the role of Stella Kowalski. Dunmyer imbues Stella with a touching combination of passion and practicality. Her connubial sexiness is a marvelous contrast to Blanche's esoteric perversity.",
    },
    {
        title: "The Water Children",
        subtitle: null,
        source: "The Boston Globe",
        text: "Deanna Dunmyer has the all-too-rare knack of turning ordinary expression into artistry, exploiting every shading the author provides.",
    },
    {
        title: "Metrmag",
        subtitle: null,
        source: "Kevin T. Baldwin",
        text: "The show is engaging from beginning to end... Dunmyer is simply absorbing in her portrayal of the domineering Aunt.",
    },
    {
        title: "Theatre Mirror",
        subtitle: null,
        source: "Shelley A. Sackett",
        text: "Along the way, we are introduced to characters who add spice while moving the plot along. Wealthy Aunt March (a terrific Deanna Dunmyer) wants to take Jo under her wing and treat her to a tour of Europe, but only if she agrees to change from a tomboy to a proper society lady. Their duet, “Could You?” is as musically stunning as it is hilarious. Dunmyer steals every scene she is in with her acerbic wit and perfect, sing-song cadence.",
    },
    {
        title: "Little Women",
        subtitle: null,
        source: "Boston Arts Diary",
        text: "What a wonderful production! ... The range of the acting here is wonderful – sometimes very funny and accentuated in hilarious ways, sometimes exceptionally nuanced and touching. ... As Aunt March, Deanna Dunmyer is outright hilarious; she could easily have embodied a stale and alienating part as the old, wealthy, nasty relative, but Dunmyer makes such wonderfully punctuated gestures at every turn that the character becomes a real hit – one waits to see what her next gag will be.",
    },
    {
        title: "Bill W. and Dr. Bob",
        subtitle: null,
        source: "EdgeMediaNetwork",
        text: "Carver and Deanna Dunmyer play a panoply of supporting roles - Dunmyer so skillfully, she’s scarcely recognizable each time she materializes in a fresh guise.",
    },
    {
        title: "The Taming of the Shrew",
        subtitle: null,
        source: "New Haven Register",
        text: "Deanna Dunmyer, a tiny spitfire, projects a most attractive, ravishingly beautiful Kate, even when at her most shrewish. It's as if her bad temper is only in fun.",
    },
    {
        title: "The Taming of the Shrew",
        subtitle: null,
        source: "Stamford Advocate",
        text: "The undisputed star of the show is Deanna Dunmyer, a red-headed fury whose shrewish Kate is irresistible. When she is on stage, all eyes are on her. Her eloquent voice carries a power astonishing in her tiny stature.  Whether growling with menace or cooly declaring her newfound obedience, she is always fully mistress of the situation. The show is worth seeing for her performance alone.",
    },
    {
        title: "Spellbinding 'Hostage'",
        subtitle: null,
        source: "Brooklyn Phoenix",
        text: "Very much the practiced ensemble, some performances etched themselves with special clarity. The Irish accent fell most liltingly off the tongue of Deanna Dunmyer as Teresa.  Dunmyer was effortlessly at home with the look and sound of Teresa's voice and with everything else the role seemed to ask of her. Her scenes with the hostage held some ravishingly quiet and moving moments.",
    },
    {
        title: "A Romeo and Juliet to Die For",
        subtitle: null,
        source: "New Haven Register",
        text: "Seldom has a Juliet blazed across the Verona sky with the youthful radiance and vitality of an actress such as Deanna Dunmyer.  Seldom has Shakespeare's 'Romeo and Juliet' been as securely anchored by its Juliet. If Dunmyer dominates it's because she's one of those performers who carries her own built-in spotlight and because of the assured way she sculpts her lines.  Lloyd's Romeo is boyishly, thoughtlessly ardent; Dunmyer's Juliet,  a gallant 13 year old who already knows her own mind.  Each play together beautifully, each able to look as though they're teens, each able to encompass their roles with skill and flair. Their genuine youthfulness makes the ensuing tragedy all the more telling.",
    },
    {
        title: "Arms and the Man",
        subtitle: null,
        source: "Houston Press",
        text: "With her distinctive toffee-stuck-to-the-roof-of-the-mouth voice, diminutive Deanna Dunmyer is so spirited as the saucy servant girl Louka that by plays' end the very sound of her character's name seems to embody a tantalizing and impish sexiness.",
    },
    {
        title: "'Three Sisters' Gleams",
        subtitle: null,
        source: "Houston Chronicle",
        text: "Deanna Dunmyer's Natasha develops from gawky hoyden to manipulative virago... funny and on-target.",
    },
    {
        title: "'Three Sisters' Gleams",
        subtitle: null,
        source: "Houston Post",
        text: "As Natasha, Deanna Dunmyer was audience-pleasingly comical.",
    },
    {
        title: "Lend Me a Tenor",
        subtitle: "",
        source: "The Democrat and Chronicle",
        text: "Deanna Dunmyer shines as Maggie. She wonderfully balances Maggie's innocence and barely controlled eager sexuality.",
    },
    {
        title: "A Member of the Wedding",
        subtitle: null,
        source: "Rochester City News",
        text: "Deanna Dunmyer's takes an extraordinarily physical approach to Frankie's character... She reveals Frankie's sensitivity and her desperation, she is also a tomboy, perpetually in motion as if sheer energy can tamp down Frankie's fears.",
    },
    {
        title: "The Fantasticks",
        subtitle: null,
        source: "The Argus Champion",
        text: "Deanna Dunmyer lights up the stage with her capricious Luisa.  Her soprano voice has an operatic range, especially appealing in the love duets.",
    },
    {
        title: "Act of Passion",
        subtitle: null,
        source: "Houston Post",
        text: "Deanna Dunmyer was every inch the Victorian bubblehead as Rosa Bud... stylish and amusing.",
    },
];

module.exports = { PRESS_REVIEWS };